import React from 'react';
import { Survey as ReactUISurvey } from 'survey-react-ui';

interface SurveyProps {
  surveyModel: any;
}

/** Simple wrapper for a React SurveyJS Survey. */
function Survey({ surveyModel }: SurveyProps) {
  return (
    <div data-testid="survey-component">
      <ReactUISurvey model={surveyModel} />
    </div>
  );
}

export default Survey;
